import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';
import { EthereumIcon, PolygonIcon } from '../styles/imgMapping';

// mapping mainnet and testnet to chain alias
export const chains = [
  {
    id: 1,
    name: 'eth',
    shortName: 'ETH',
    rpc: 'https://mainnet.infura.io/v3/895203abafe34efb9af3597f0c105c00',
    metamaskDefaultRPC: 'https://mainnet.infura.io/v3/',
    enabled: true,
    network: 'mainnet',
    display: 'ETH',
    icon: EthereumIcon,
  },
  {
    id: 3,
    name: 'eth',
    shortName: 'ETH',
    rpc: 'https://ropsten.infura.io/v3/d9044d96244b426fb3bbe68c46c848cb',
    metamaskDefaultRPC: 'https://ropsten.infura.io/v3/',
    enabled: false,
    network: 'testnet',
    display: 'Ethereum Testnet - Ropsten',
    icon: EthereumIcon,
  },
  {
    id: 4,
    name: 'eth',
    shortName: 'ETH',
    rpc: 'https://rinkeby.infura.io/v3/d9044d96244b426fb3bbe68c46c848cb',
    metamaskDefaultRPC: 'https://rinkeby.infura.io/v3/',
    enabled: false,
    network: 'testnet',
    display: 'Ethereum Testnet - Rinkeby',
    icon: EthereumIcon,
  },
  {
    id: 5,
    name: 'eth',
    shortName: 'ETH',
    rpc: 'https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    metamaskDefaultRPC: 'https://goerli.infura.io/v3/',
    enabled: false,
    network: 'testnet',
    display: 'Ethereum Testnet - Goerli',
    nativeCurrency: {
      name: 'Goerli ETH',
      symbol: 'gorETH',
      decimals: 18,
    },
    icon: EthereumIcon,
  },
  {
    id: 11155111,
    name: 'eth',
    shortName: 'ETH',
    rpc: 'https://sepolia.infura.io/v3/ebec24a431234429a6f464da2e4f98c5',
    metamaskDefaultRPC: 'https://sepolia.infura.io/v3/',
    enabled: true,
    network: 'testnet',
    display: 'Ethereum Testnet - Sepolia',
    nativeCurrency: {
      name: 'Sepolia ETH',
      symbol: 'SepoliaETH',
      decimals: 18,
    },
    icon: EthereumIcon,
  },
  {
    id: 137,
    name: 'polygon',
    shortName: 'Polygon',
    rpc: 'https://polygon-rpc.com',
    enabled: true,
    network: 'mainnet',
    display: 'Polygon Mainnet',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    icon: PolygonIcon,
  },
  {
    id: 80001,
    name: 'polygon',
    shortName: 'Polygon',
    rpc: 'https://polygon-mumbai-bor-rpc.publicnode.com',
    enabled: true,
    network: 'testnet',
    display: 'Polygon Testnet - Mumbai',
    nativeCurrency: {
      name: 'Testnet MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    icon: PolygonIcon,
  },
].filter((c) => c.enabled);

export const chainMapping = keyBy(chains, 'id');

export const walletRpcConnectConfig = mapValues(chainMapping, (c) => c.rpc);

export const getSwitchNetworks = () => {
  const isApplicationMainnet = (process.env.REACT_APP_NETWORK || 'TESTNET') === 'MAINNET';
  const availableChains = chains.filter((chain) =>
    isApplicationMainnet ? chain.network === 'mainnet' : chain.network === 'testnet',
  );

  return availableChains.map((chain) => {
    const { display, id, rpc, metamaskDefaultRPC, nativeCurrency } = chain;
    return {
      id,
      url: metamaskDefaultRPC || rpc,
      chainName: display,
      nativeCurrency,
      icon: chain.icon,
    };
  });
};
